import {
  enhanceWrapped,
  InputBase,
} from '../../../../../configure/components/InputBase';

const INPUT_LABEL = 'Confirmation';
const INPUT_PLACEHOLDER = 'Thank you. Your request has been processed.';
const FIELD_TO_UPDATE = 'unsubscribeProcessedMessage';

const enhance = enhanceWrapped(FIELD_TO_UPDATE, INPUT_LABEL, INPUT_PLACEHOLDER);
const UnsubscribeProcessedMessage = enhance(InputBase);

export default UnsubscribeProcessedMessage;
